// TODO: Move this icon to @raydiant/raydial as a proper icon component
import { FC, SVGProps } from 'react';

interface PlusIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

const PlusIcon: FC<PlusIconProps> = ({ size = 13, className, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M7.25 0.75V5.75H12.25C12.6562 5.75 13 6.09375 13 6.5C13 6.9375 12.6562 7.25 12.25 7.25H7.25V12.25C7.25 12.6875 6.90625 13 6.5 13C6.0625 13 5.75 12.6875 5.75 12.25V7.25H0.75C0.3125 7.25 0 6.9375 0 6.5C0 6.09375 0.3125 5.75 0.75 5.75H5.75V0.75C5.75 0.34375 6.0625 0 6.5 0C6.90625 0 7.25 0.34375 7.25 0.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PlusIcon;
